import { render, staticRenderFns } from "./FeaturedNavigation.vue?vue&type=template&id=5bb4b627&"
import script from "./FeaturedNavigation.vue?vue&type=script&lang=js&"
export * from "./FeaturedNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports